export function formatCents(cents, currency = 'USD') {
  const n = Number(cents) / 100;
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(n);
  } catch {
    return `${currency} ${n.toFixed(2)}`;
  }
}

/** Monto en pesos enteros ARS (sin dividir por 100). */
export function formatCurrencyARS(pesos) {
  const n = Number(pesos);
  if (Number.isNaN(n)) return '$ 0';
  try {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(Math.round(n));
  } catch {
    return `$ ${Math.round(n).toLocaleString('es-AR')}`;
  }
}

export function formatDate(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString();
}
